import { FormType } from '../../contactUs/data/constants';

export enum contactUsModalEvents {
    SHOW_CONTACT_US = 'contactUsModal/show',
    HIDE_CONTACT_US = 'contactUsModal/hide',
}

const showContactUsModal = function (formType = FormType.DEFAULT, customFormOptions = {}, options = {}) {
    const event = new CustomEvent(contactUsModalEvents.SHOW_CONTACT_US, {
        detail: {
            ...options,
            formType,
            customFormOptions,
        },
    });
    window.dispatchEvent(event);
};

const hideContactUsModal = function () {
    window.dispatchEvent(new CustomEvent(contactUsModalEvents.HIDE_CONTACT_US));
};

export default {
    showContactUsModal,
    hideContactUsModal,
};
